<template>
    <div class="layout-footer">
        <div class="footer-logo-container">
            <img id="footer-logo" src="assets/layout/images/logo-mides.svg" alt="mides - layout" />
            <span class="app-name">PAT QR</span>
        </div>
        <span class="copyright">&#169; MIDES - 2026 | v3.0</span>
    </div>
</template>

<script>
export default {
    name: "AppFooter"
};
</script>